<template>
  <div class="body">
    <div class="title">
            <span class="search">
                <el-input class="searchInput"
                          :value="clients.key"
                          @input="input($event,1)"
                          @change="search"
                          placeholder="姓名/手机号"></el-input>
                <el-input class="remarkInput"
                          @change="search"
                          :value="clients.remark"
                          @input="input($event,2)"
                         placeholder="备注"></el-input>
            </span>
      <span class="sortA">
                <el-select :value="clients.datumStatus" @change="input($event,3)" placeholder="审核状态">
                <el-option v-for="item in statusType" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
                </el-select>
            </span>
      <span class="sortB">
                  <el-date-picker v-model="time"
                                  value-format="yyyy-MM-dd"
                                  type="daterange"
                                  range-separator="-"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  @change="input($event,6)">
                  </el-date-picker>
            </span>
      <span class="sortC">
                <el-select :value="clients.source"
                           @change="input($event,7)"
                           placeholder="客户类型">
                <el-option v-for="item in custTypeList"
                           :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
                </el-select>
            </span>
      <span class="sortC">
                <el-select :value="clients.roleId"
                           @change="input($event,4)"
                           placeholder="会员类型">
                <el-option v-for="item in vipTypeList"
                           :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
                </el-select>
            </span>
      <span class="sortD">
                <el-input class="inputDepart"
                          :value="clients.departmentKey"
                          @input="input($event,5)"
                          placeholder="部门(员工)名/编号"></el-input>
            </span>
      <span class="sortE">
                <el-button
                  style="margin-left:0.5rem"
                  type="primary" @click="search">查询</el-button>
                <el-button plain @click="reset">重置</el-button>
            </span>
    </div>
    <div class="content">
      <div class="table">
        <el-table :data="gainPagClinets" :header-cell-style="tableHeaderColor"
                  v-loading="loading"
                  style="width: 100%"
                  :row-class-name="removeRowClassName"
        >
          <el-table-column prop="name"
                           label="姓名" width="100">
            <template slot-scope="scope">
                <span style="position: relative;padding: 2px 0;color:#0f86da"
                      @click="customerDetails(scope.row.id)"
                      :style="{color:scope.row.isRemove ? '#000000' : '#0f86da'}"
                >{{ scope.row.name }}
                 <div class="underline" v-if="!scope.row.isRemove"></div>
                </span>
              <!--              <a></a>-->
            </template>
          </el-table-column>
          <el-table-column prop="sex" :formatter="sexType" width="80" label="性别"
          ></el-table-column>
          <el-table-column prop="age" label="年龄" width="80"></el-table-column>
          <el-table-column prop="telNumber" width="120" label="电话"></el-table-column>
          <el-table-column prop="staffName" label="员工" width="100"></el-table-column>
          <el-table-column prop="departmentName" label="部门"></el-table-column>
          <el-table-column prop="idTypeStr" width="100" label="证件类型"></el-table-column>
          <el-table-column prop="idCard" label="证件号码"></el-table-column>
          <el-table-column prop="birthDt" label="出生日期"></el-table-column>
          <el-table-column prop="roleName" label="会员类型"></el-table-column>
          <el-table-column prop="entryDt" label="录入时间"></el-table-column>
          <el-table-column prop="datumStatus" label="审核">
            <template slot-scope="scope">
              <!-- <img class="imgHead" :src="scope.row.avatar"/> -->
              <el-button :type="colorState(scope.row.datumStatus)" size="mini"
                         @click="customInfo(scope.row)"
                         :style="{backgroundColor:scope.row.isRemove ? '#ebeef5' : '',
                         color:scope.row.isRemove ? 'black' : '',
                         pointerEvents:scope.row.isRemove ? 'none' : '',
                         border:scope.row.isRemove ? '1px solid #ebeef5' : ''
                         }"
              >
                {{ datumStatusType(scope.row.datumStatus) }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="operation" v-if="!scope.row.isRemove">
                <i class="iconfont distance"
                   @click="customerDetails(scope.row.id)"
                   style="color:#5994FF">&#xe63a;</i>
                <i class="iconfont icon-shanchu distance"
                   @click="removeCilent(scope.row.id)"
                   style="color:red"></i>
                <i class="iconfont icon-ren distance"
                   @click="careOfclient(scope.row.id)"
                   style="color:red"></i>
                <i class="iconfont icon-suo distance"
                   v-if="scope.row.staffName"
                   @click="unlockClient(scope.row.id)"
                   style="color:#5994FF"></i>
              </div>
            </template>

          </el-table-column>
        </el-table>
        <span class="customNumber">客户人数:{{ clients.total }}人</span>
        <span class="customPage">
                  <el-pagination background layout="prev, pager, next" :current-page="clients.current"
                                 @current-change="handleCurrentChange"
                                 :page-size="clients.size" :total="clients.total">

                  </el-pagination>
                </span>
      </div>
      <el-dialog title="请填写异常项目" :visible.sync="dialogVisible" width="30%">
        <el-checkbox v-for="(item,index) in exceptionForm.exceptions" :key="index" v-model="item.possess">
          {{ item.exceptionName }}
        </el-checkbox>
        <el-input class="textException" type="textarea" v-model="exceptionForm.remark" :rows="2"
                  placeholder="请输入内容"></el-input>
        <span>
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sendException">确 定</el-button>
                </span>
      </el-dialog>
      <el-dialog title="请选择转交员工" :visible.sync="isCareOf" width="25%">
        <el-autocomplete
          style="width:90%;height:36px"
          popper-class="my-autocomplete"
          v-model="client"
          :fetch-suggestions="querySearch"
          placeholder="请输入姓名和电话"
          ref="elAutocomplete"
          @select="handleSelect"
          :trigger-on-focus="true"
        >
          <i
            class="el-icon-search"
            style="font-size: 20px;margin-top: 11px"
            slot="suffix"
            @click="showSearchColumn"
          >
          </i>
          <template slot-scope="{ item }">
            <div class="search-title" v-if="item.id === subOneId">
              <span>姓名</span>
              <span >电话</span>
              <span >所属部门</span>
            </div>
            <div class="search-list-content" >
              <span >{{ item.name }}</span>
              <span >{{ item.telNumber }}</span>
              <span >{{ item.departmentName }}</span>
            </div>
          </template>
        </el-autocomplete>
        <textarea
        v-model="remark"
        class="remark-info"
        placeholder="请填写备注信息"
        ></textarea>
        <div slot="footer" class="dialog-footer">
<!--          <el-button @click="dialogFormVisible = false">取 消</el-button>-->
          <el-button type="primary" @click="transferClient">确认转移</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "../../axios/axios";
import {Message} from "element-ui";
import ipAddress from "../../axios/ipAddress";
import {
  CLIENT_CONDITION_VARIATION,
  CLIENT_INIT_DATUM,
  CLIENT_PAGINATION_VARIATION,
  CLIENT_REQUSET_PARAM,
  CLIENT_RESET_CONTENT, CLIENT_TRANSFER
} from "../../vuex/client/type";

export default {
  data() {
    return {
      sorts: [
        {
          sortColumn: 'id',
          sortType: 'DESC',
        }
      ],
      isCareOf:false,
      loading: true,
      time: '',
      statusType: null,
      vipTypeList: [],
      dialogVisible: false,
      custTypeList:[],
      exceptionForm: {
        exceptions: null,
        customerId: null,
        remark: null,
      },
      client:'',
      subOneId:0,
      clientId: 0,
      remark:'',
      clientCode:'',
      BOTID:0,
      searchs:[]
    }
  },
  mounted() {
    this.filtrate()
    this.$store.dispatch(`client/${CLIENT_INIT_DATUM}`,true) //初始化数据
  },
  computed:{
    //获取vuex的全部参数
    clients(){
       return this.$store.getters["client/getGlobalParam"]
    },
    //获取列表数据
    gainPagClinets(){
      this.loading = false  //关闭加载动画
      return this.$store.getters["client/getPagCients"]
    }
  },
  methods: {

    //客户详情
    customInfo(row) {
      this.$router.replace(`/index/customInfo/${row.id}`)
    },

    //返回输入建议的方法，仅当你的输入建议数据 resolve 时，通过调用 callback(data:[]) 来返回它
    querySearch(text, callback) {
      if (text) {
        let params = {
          key:text,
          type:0
        }
        axios.post(`${ipAddress.qi}/admin/a1/staff/queryLimited`, params,true).then(
          value => {
            let content = value.content
            if (!content || content.length < 1) {
              content = [{id: -1, name: "暂无匹配数据"}]
            }else {
              this.subOneId = content[0].id //记录第一个姓名的id用于判断
              this.searchs = content
            }
            // 调用 callback 返回建议列表的数据
            callback(content)
          }
        )
      }
    },

    showSearchColumn(){
      this.$refs.elAutocomplete.handleFocus()
    },

    //输入框的input事件
    input(event,type){
      this.$store.commit(`client/${CLIENT_REQUSET_PARAM}`,
        {
          type:type,
          content:event
        })
    },

    //仅在输入框失去焦点或用户按下回车时触发
    handleSelect(event) {
      this.client = event.name
      this.clientId = event.id
      this.clientCode = event.jobNumber
    },


    //查看客户信息
    customerDetails(id) {
      this.$router.replace(`customers/basicinfo/${id}/${1}`)
    },

    //删除行样式
    removeRowClassName({row, rowIndex}) {
       if(row.isRemove){
         return "warning-row"
       }
       return ""
    },
    //异常处理
    exception(row) {
      if (row.datumStatus != 2) {
        this.joker.customer.getExceptionList(row.id).then(res => {
          this.exceptionForm = res.content
          this.dialogVisible = true
          this.exceptionForm.customerId = row.id
          this.exceptionForm.state = row.datumStatus
        })
      }
    },
    //确定推送异常
    sendException() {
      if (this.exceptionForm.state == 0) {//添加
        this.joker.customer.addException(this.exceptionForm).then(res => {
          this.dialogVisible = false
          this.customerList()
        })
      } else {//编辑
        this.joker.customer.updateException(this.exceptionForm).then(res => {
          this.dialogVisible = false
          this.customerList()
        })
      }
    },

    //筛选条件
    filtrate() {
      this.joker.customer.getVipTypeAndExceptionStatus().then(res => {
        this.statusType = res.content.exceptionStatus
        this.vipTypeList = res.content.vipType
        this.custTypeList = res.content.customerType
      })
    },

    //分页
    customerList() {
      this.loading = true
      this.joker.customer.customerList(this.page).then(res => {
        console.log(res)
        this.list = res.content.records
        this.total = res.content.total
        this.loading = false
      })
    },

    //下一页
    handleCurrentChange(val) {
      this.$store.dispatch(`client/${CLIENT_PAGINATION_VARIATION}`,val)
      // this.page.current = val
      // window.localStorage.setItem("clientPage",`${val}`)
      // this.customerList();
    },
    //搜索
    search() {
      //将数据重新初始化掉
      this.$store.dispatch(`client/${CLIENT_CONDITION_VARIATION}`)
      // this.page.current = 1
      // this.customerList();
    },

    //性别判断
    sexType(row, column) {
      if (row.sex == 1) {
        return '男'
      } else {
        return '女'
      }
    },
    //审核状态判断
    datumStatusType(state) {
      switch (state) {
        case 0:
          return '未审核'
          break;
        case 1:
          return '审核中'
          break;
        case 2:
          return '已修改'
          break;
        case 3:
          return '已审核'
          break;
      }
    },
    //状态颜色
    colorState(state) {
      switch (state) {
        case 0:
          return 'warning'
          break;
        case 1:
          return 'danger'
          break;
        case 2:
          return 'primary'
          break;
        case 3:
          return 'success'
          break;
      }
    },


    // 修改table header的背景色
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return 'background-color: #ECEEF0;color: #606266;'
      }
    },

    // timeSection(e) {
    //   this.page.condition.startDt = this.time[0] + ' 00:00:00'
    //   this.page.condition.endDt = this.time[1] + ' 23:59:59'
    // },
    //重置
    reset() {
      this.$store.dispatch(`client/${CLIENT_RESET_CONTENT}`)
    },

    //点击删除客户
    removeCilent(id){
      let params = new URLSearchParams()
      params.set("id",id)
      axios.post(`${ipAddress.qi}/admin/a1/customer/delById`,params).then(
        value =>{
          const success = value.success
          const msg = value.message
          if(success){
            Message.success("删除成功！")
            //删除客户后重新拉去一下该页面数据
            this.$store.dispatch(`client/${CLIENT_INIT_DATUM}`)
          }else {
            Message.warning(msg)
          }
        }
      )
    },
    //解锁客户
    unlockClient(id){
      let params = new URLSearchParams()
      params.set("id",id)
      axios.post(`${ipAddress.qi}/admin/a1/customer/releaseById`,params).then(
        value => {
          const success = value.success
          const msg = value.message
          if(success){
            Message.success("释放成功！")
            const  index = this.list.findIndex(el =>el.id === id)
            this.list[index].staffName = null  //将员工这栏信息改成null
          }else {
            Message.warning(msg)
          }
        }
      )
    },
    //点击转交客户
    careOfclient(id){
      this.BOTID = id
      //打开转交蒙层
      this.isCareOf = true
    },
    //点击确认转移
    transferClient(){
      const params = {
        id:this.BOTID,
        newCode:this.clientCode,
        remark:this.remark
      }
      axios.post(`${ipAddress.qi}/admin/a1/customer/turnOverByCode`,params,true).then(
        value =>{

          const success = value.success

          const msg = value.message

          if(success){

            const [clientInfo] = this.searchs.filter(el =>el.id === this.clientId)

            this.$store.commit(`client/${CLIENT_TRANSFER}`,
              {
                BOTID:this.BOTID,
                info:clientInfo
              })
            // this.list = this.list.map(el =>{
            //   return {...el,staffName:el.id === this.BOTID ? clientInfo.name : el.staffName,
            //     departmentName:el.id === this.BOTID ? clientInfo.departmentName : el.departmentName
            //   }
            // })
            //清除备注
            this.remark = ''
            //清除输入框内容
            this.client = ''

            this.isCareOf = false

            Message.success("移交成功！")
          }else {
            console.log(1)
            Message.warning(msg)
          }
        }
      )
    }
  },
}
</script>
<style>
.el-table .warning-row {
  background: #DCDCDC;
  pointer-events: none;
}
.el-dialog__header {
  padding: 15px 15px 7px;
}
.el-dialog__headerbtn{
  margin-top: -5px;
}
.el-dialog__body{
  padding:20px 20px 5px 20px
}
</style>
<style scoped>
.body {
  padding: 10px
}
.dialog-footer{
  text-align: center;
}
.title {
  background-color: #FFFF;
  width: 98%;
  line-height: 60px;
  margin-bottom: 0.5%;
  border-radius: 10px;
  /*display:flex;*/
  /*align-items: center;*/
}

.search {
  display: inline-block;
  width: 43%;
  /* top: 20%; */
  /* width:700px; */
  /* background-color: #5790DF; */
}

.searchInput {

  width: 30%;
  margin-left: 1%;
}
.remarkInput{
  width:30%;
  margin-left: 2%;
}

.sortA {
  display: inline-block;
  width: 7%;
}

.sortB {
  display: inline-block;
  width: 21%;
}

.sortC {
  display: inline-block;
  width: 7%;
}

.content {
  border-radius: 10px;
  width: 98%;
  background-color: #FFFFFF;
  margin-left: 1%;
}

.table {
  width: 98%;
  margin-left: 1%;
  padding-bottom: 1%;
  padding-top: 1%
}

.contentState {
  text-align: left;
  background-color: #FFFF;
  padding-top: 1%;
  padding-left: 0.5%;
  font-size: 18px;
  border-radius: 10px;
}

.stateA {
  color: #5790DF;
}

.stateB {
  margin-left: 2%
}

.customNumber {
  display: inline-block;
  width: 25%;
  text-align: left;
  line-height: 60px;
  font-size: 18px;
  font-weight: 600;
  /* background-color: aqua; */
}

.customPage {
  display: inline-block;
  width: 70%;
  line-height: 40px;
  text-align: right;
  /* background-color: beige; */
  vertical-align: middle;
  padding-top: 10px;
}

.inputDepart {
  width: 10%;
}

.textException {
  margin-top: 3%;
  margin-bottom: 3%;
}

.distance {
  margin: 0.2rem;
  font-size: 1.2rem;
}

.underline {
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  left: 0;
  border: 1px solid #0f86da;
}

.search-title {
  width: 100%;
  height: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  color: black;
  letter-spacing: 1px;
}

.search-list-content {
  width: 100%;
  height: auto;
  padding: 0.1rem 0;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  letter-spacing: 1px;
  color: #717171;
}
.remark-info{
  width: 90%;
  height: 5rem;
  outline: none;
  border: 1px solid #DCDFE6;
  border-radius: 5px;
  margin-top: 1rem;
  padding: 0.3rem 0.3rem 0.3rem 1rem;
  letter-spacing: 2px;
}
.remark-info::-webkit-input-placeholder{
  color:#9F9F9F;
}

.imgOpera {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/customerList.vue